export const SET_EXPANDER_OPEN = 'set-expander-open';
export const SET_EXPANDER_HOPS = 'set-expander-hops';
export const SET_EXPANDER_DIRECTION = 'set-expander-direction';
export const COMMIT_EXPANSION = 'commit-expansion';

export const setExpanderOpen = props => ({
  ...props,
  type: SET_EXPANDER_OPEN
});

export const setExpanderHops = props => ({
    ...props,
    type: SET_EXPANDER_HOPS
});

export const setExpanderDirection = props => ({
    ...props,
    type: SET_EXPANDER_DIRECTION
});

export const commitExpansion = props => ({
  ...props,
  type: COMMIT_EXPANSION
})
